import React from 'react';
import styled from 'styled-components';

import moment from 'moment';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';

import { LinkOutlined } from '@ant-design/icons';

import Types from '../../modules/types';

import getStoreUrl from '../../helpers/getStoreUrl';
import {
  columnCreatedAt,
  columnUpdatedAt,
} from '../../components/common';

const {
  STORE_TYPE_LABELS_MAP,
} = Types;

const StoreIdWrapper = styled.span`
  font-family: ${({ theme }) => theme.monospaceFontStack};
  opacity: 0.8;
  font-size: 90%;
`;

export const columnName = {
  path: 'name',
  sort: 'name',
  render: record => (
    <span>
      <a
        href={getStoreUrl(record)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <LinkOutlined />
      </a>
      &nbsp;
      &nbsp;
      <Link to={`/stores/${record._id}`}>
        {record.name}
      </Link>
      {
        record.archived || !record.active
        ? (
            <>
              &nbsp;
              /
              &nbsp;
              <span style={{ opacity: 0.7 }}>
                {
                  record.archived
                  ? 'ARCHIVED'
                  : 'INACTIVE'
                }
              </span>
            </>
          )
        : null
      }
    </span>
  ),
};

export const columnStoreId = {
  path: 'storeId',
  title: 'ID',
  render: record => (
    <StoreIdWrapper>
      {record.storeId}
    </StoreIdWrapper>
  ),
};

export const columnType = {
  path: 'type',
  render: record => (
      record.internal === true
    ? 'Internal'
    : STORE_TYPE_LABELS_MAP[record.type]
  ),
};

export const columnSubscriptionStatus = {
  path: 'subscriptionStatus',
  title: 'Status',
  align: 'right',
  render: record => (
      !record.subscriptionStatus
    ? '-'
    : record.subscriptionStatus.label
  ),
};

export const columnSubscription = {
  path: 'subscription',
  title: 'Plan',
  render: record => (
      record.subscriptionInUse
    ? `${
        record.subscriptionInUse.legacy ? 'Legacy: ' : ''
      }${
        record.subscriptionInUse.label
      }`
    : '-'
  ),
};

export const columnSubscriptionNextDueAt = {
  path: 'subscriptionNextDueAt',
  title: 'Next Due Date',
  render: record => (
      record.subscriptionNextDueAt
    ? moment(record.subscriptionNextDueAt).format('ll')
    : '-'
  ),
};

export const columnFeatured = {
  path: 'featured',
  render: record => (
    record.featured > 0
    ? record.featured
    : 'N/A'
  ),
};

export const columnListed = {
  path: 'listed',
  render: record => (
    record.listed
    ? 'YES'
    : 'NO'
  ),
};

export const COLUMNS = [
  columnName,
  columnStoreId,
  columnType,
  columnSubscriptionStatus,
  columnSubscription,
  columnSubscriptionNextDueAt,
  columnCreatedAt,
  columnUpdatedAt,
  // columnFeatured,
  // columnListed,
];
